import type { IAngularEvent, IFormController, IScope } from "angular";
import { isFunction } from "angular";

import { ButtonComponentController } from "../Common/ButtonComponentController";
import type { IButtonEvent } from "../Common/IButtonEvent";

export class SubmitButtonComponentController extends ButtonComponentController {
    public static $inject = ["$scope"];

    public onSubmit?: (data: IButtonEvent) => void;

    public formCtrl: IFormController;

    constructor(private readonly scope: IScope) {
        super();
    }

    public $onInit() {
        this.formCtrl.$$element.on("submit", (event: any) => {
            event.preventDefault();

            this.formCtrl.$aaFormExtensions.$onSubmitAttempt();

            if (this.formCtrl.$valid) {
                this.submitClick(event);
                this.formCtrl.$setSubmitted();
            }

            this.scope.$apply();
        });
    }

    public $onDestroy() {
        this.formCtrl.$$element.off("submit");
    }

    public submitClick($event: IAngularEvent) {
        if (isFunction(this.onSubmit)) {
            this.onSubmit({ $event });
        }
    }
}
